import gql from 'graphql-tag';
import { Layout } from '../../components';
import React from 'react';
import { useQuery } from 'react-apollo';
import { RouteComponentProps } from 'react-router';
import { LayoutContent } from '../../components/LayoutContent';
import { Navigation } from '../../components/Navigation';
import { TopBarDatePicker } from '../../components/TopBarDatePicker';
import { useStartAndEnd } from '../../hooks';
import { DemographicsQuery } from './__generated__/DemographicsQuery';
import { Demographics as DemographicsComponent } from './Demographics';

const query = gql`
  query DemographicsQuery($venueId: ID!, $start: String!, $end: String!) {
    demographics(venueId: $venueId, start: $start, end: $end) {
      averageSpendPerNight
      reorderPercentages
      topCustomersOrders {
        count
        firstName
        lastName
      }
      topCustomersDrinks {
        count
        firstName
        lastName
      }
      genders {
        count
        name
      }
      averageReorderTime {
        hours
        minutes
        seconds
      }
    }
  }
`;

type RouterProps = RouteComponentProps<{ venueId: string }>;

interface DemographicsProps extends RouterProps {
  data?: DemographicsQuery;
  start: Date;
  end: Date;
  loading: boolean;
  error: Error | null;
  venueId: string;
}

class DemographicsWithLayout extends React.Component<DemographicsProps> {
  handleDatePickerChange = (start, end) => {
    const { venueId } = this.props;
    this.props.history.push(`/venue/${venueId}/demographics?start=${start.toISOString()}&end=${end.toISOString()}`);
  };

  render() {
    const { start, end, loading, data } = this.props;

    return (
      <Layout>
        <Navigation />
        <Layout.TopBar>
          <Layout.TopBar.Left>
            <Layout.TopBar.Title>Demographics</Layout.TopBar.Title>
          </Layout.TopBar.Left>
          <Layout.TopBar.Right>
            <TopBarDatePicker start={start} end={end} onSubmit={this.handleDatePickerChange} />
          </Layout.TopBar.Right>
        </Layout.TopBar>
        <LayoutContent error={this.props.error}>
          <DemographicsComponent loading={loading} stats={data ? data.demographics : undefined} />
        </LayoutContent>
      </Layout>
    );
  }
}

export const Demographics = (props: RouterProps) => {
  const { start, end } = useStartAndEnd();
  const { venueId } = props.match.params;
  const variables = {
    venueId,
    start: start.toISOString(),
    end: end.toISOString(),
  };

  const { loading, error, data } = useQuery(query, {
    variables,
  });

  return (
    <DemographicsWithLayout
      {...props}
      start={start}
      end={end}
      loading={loading}
      error={error}
      data={data}
      venueId={venueId}
    />
  );
};
